import React from 'react';
import { SectionWrapper, Countdown, Button } from './ui';
import { AlertTriangleIcon, CheckCircle2Icon } from 'lucide-react';
export const Urgency = () => {
  return <div className="bg-dark-card border-y border-dark-border py-12 text-center" data-id="element-131">
      <div className="max-w-3xl mx-auto px-4" data-id="element-132">
        <div className="flex items-center justify-center gap-2 text-accent mb-6" data-id="element-133">
          <AlertTriangleIcon size={24} data-id="element-134" />
          <h2 className="text-xl md:text-2xl font-bold uppercase tracking-wider" data-id="element-135">
            Precio de lanzamiento — Cierra en:
          </h2>
        </div>

        <div className="mb-8" data-id="element-136">
          <Countdown data-id="element-137" />
        </div>

        <p className="text-xl text-red-400 font-bold mb-8" data-id="element-138">
          ⚠️ Después sube $8.000 ARS. No vuelve.
        </p>

        <div className="max-w-md mx-auto" data-id="element-139">
          <div className="flex justify-between text-sm text-gray-400 mb-2 font-medium" data-id="element-140">
            <span data-id="element-141">Cupos al precio de lanzamiento</span>
            <span data-id="element-142">Quedan pocos</span>
          </div>
          <div className="w-full bg-dark-bg rounded-full h-4 border border-dark-border overflow-hidden" data-id="element-143">
            <div className="bg-gradient-to-r from-accent to-red-500 h-full rounded-full" style={{
            width: '68%'
          }} data-id="element-144"></div>
          </div>
          <p className="text-xs text-gray-500 mt-2 text-right" data-id="element-145">
            68% de los cupos ya tomados
          </p>
        </div>
      </div>
    </div>;
};
export const PricingCards = () => {
  return <SectionWrapper id="pricing" className="bg-dark-bg" data-id="element-146">
      <div className="text-center mb-12" data-id="element-147">
        <h2 className="text-4xl md:text-5xl font-black text-white mb-4" data-id="element-148">
          ELEGÍ TU KIT
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto items-center" data-id="element-149">
        <div className="bg-dark-card border border-dark-border rounded-3xl p-8 shadow-xl" data-id="element-150">
          <h3 className="text-2xl font-bold text-white mb-2" data-id="element-151">
            🐾 KIT PROFESIONAL DEL CUIDADOR 360™
          </h3>
          <p className="text-primary font-medium mb-6" data-id="element-152">6 Tomos + 6 Bonos</p>

          <div className="bg-dark-bg rounded-xl p-4 mb-8 border border-dark-border" data-id="element-153">
            <p className="text-sm text-gray-400" data-id="element-154">Ideal para:</p>
            <p className="text-white font-medium" data-id="element-155">
              Cuidadores que quieren profesionalizarse desde hoy
            </p>
          </div>

          <div className="mb-8" data-id="element-156">
            <p className="text-gray-500 line-through text-xl mb-1" data-id="element-157">$67.000</p>
            <p className="text-5xl font-black text-white" data-id="element-158">
              $19.500{' '}
              <span className="text-2xl text-gray-400 font-bold" data-id="element-159">ARS</span>
            </p>
          </div>

          <Button size="lg" className="w-full" href="https://globalnovapro.shop/cart/43941129322539:1" data-id="element-160">
            → QUIERO MI KIT PROFESIONAL AHORA
          </Button>
        </div>

        <div className="bg-gradient-to-b from-[#251a45] to-dark-card border-2 border-primary rounded-3xl p-8 shadow-[0_0_40px_rgba(139,92,246,0.15)] relative transform md:-translate-y-4" data-id="element-161">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-primary text-white px-6 py-1.5 rounded-full text-sm font-bold tracking-wider shadow-lg" data-id="element-162">
            MÁS ELEGIDO
          </div>

          <h3 className="text-2xl font-bold text-white mb-2" data-id="element-163">
            🚀 KIT COMPLETO + ACELERADOR ⭐
          </h3>
          <p className="text-primary font-medium mb-6" data-id="element-164">
            6 Tomos + 6 Bonos + Acelerador de Rentabilidad 360
          </p>

          <div className="bg-dark-bg/50 rounded-xl p-4 mb-8 border border-primary/30" data-id="element-165">
            <p className="text-sm text-primary" data-id="element-166">Ideal para:</p>
            <p className="text-white font-medium" data-id="element-167">
              Cuidadores que quieren triplicar ingresos y construir un negocio
              real
            </p>
          </div>

          <div className="mb-8" data-id="element-168">
            <p className="text-gray-500 line-through text-xl mb-1" data-id="element-169">$89.000</p>
            <p className="text-5xl font-black text-white" data-id="element-170">
              $27.500{' '}
              <span className="text-2xl text-gray-400 font-bold" data-id="element-171">ARS</span>
            </p>
          </div>

          <Button size="lg" className="w-full text-lg shadow-[0_0_20px_rgba(139,92,246,0.4)]" href="https://globalnovapro.shop/cart/43941131878443:1" data-id="element-172">
            → QUIERO EL KIT COMPLETO + ACELERADOR
          </Button>
        </div>
      </div>
    </SectionWrapper>;
};
export const Accelerator = () => {
  const comparisons = [{
    sit: 'Agenda llena sin poder crecer',
    sin: 'Techo de ingresos',
    con: 'Sistema de delegación listo'
  }, {
    sit: 'Querés subir precios',
    sin: 'Miedo de perder clientes',
    con: 'Script de aumento sin drama'
  }, {
    sit: 'Ingresos inestables',
    sin: 'Nunca sabés cuánto vas a ganar',
    con: 'Abonos mensuales predecibles'
  }, {
    sit: 'No cerrás consultas',
    sin: 'Improvisás y perdés clientes',
    con: 'Scripts de cierre listos'
  }];
  return <SectionWrapper className="bg-dark-card/30" data-id="element-173">
      <div className="text-center mb-12" data-id="element-174">
        <h2 className="text-3xl md:text-5xl font-black text-white mb-4" data-id="element-175">
          🚀 ¿QUÉ AGREGA EL ACELERADOR?
        </h2>
      </div>

      <div className="max-w-5xl mx-auto" data-id="element-176">
        <div className="overflow-x-auto rounded-xl border border-dark-border shadow-xl" data-id="element-177">
          <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-178">
            <thead data-id="element-179">
              <tr className="bg-dark-card border-b border-dark-border" data-id="element-180">
                <th className="p-4 text-sm font-bold text-gray-400 uppercase" data-id="element-181">
                  Situación en tu negocio
                </th>
                <th className="p-4 text-sm font-bold text-red-400 uppercase border-l border-dark-border bg-red-950/10" data-id="element-182">
                  ❌ Sin Acelerador
                </th>
                <th className="p-4 text-sm font-bold text-primary uppercase border-l border-dark-border bg-primary/5" data-id="element-183">
                  ✅ Con Acelerador
                </th>
              </tr>
            </thead>
            <tbody data-id="element-184">
              {comparisons.map((item, i) => <tr key={i} className="border-b border-dark-border/50 hover:bg-dark-card/50 transition-colors" data-id="element-185">
                  <td className="p-4 text-gray-300 font-medium" data-id="element-186">{item.sit}</td>
                  <td className="p-4 text-gray-400 border-l border-dark-border/50 bg-red-950/5" data-id="element-187">
                    {item.sin}
                  </td>
                  <td className="p-4 text-white font-medium border-l border-dark-border/50 bg-primary/5" data-id="element-188">
                    {item.con}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </SectionWrapper>;
};
export const FinalCTA = () => {
  return <div className="bg-dark-card border-y border-dark-border py-16" data-id="element-189">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-190">
        <h2 className="text-2xl md:text-3xl font-black text-white mb-6 uppercase tracking-wider" data-id="element-191">
          ⏰ EL PRECIO CIERRA EN:
        </h2>

        <div className="mb-12" data-id="element-192">
          <Countdown data-id="element-193" />
        </div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-194">
          <div className="bg-dark-bg border border-dark-border rounded-2xl p-6 flex flex-col justify-between" data-id="element-195">
            <div data-id="element-196">
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-197">
                🐾 KIT PROFESIONAL DEL CUIDADOR 360™
              </h3>
              <div className="mb-6" data-id="element-198">
                <span className="text-gray-500 line-through mr-2" data-id="element-199">$67.000</span>
                <span className="text-3xl font-black text-white" data-id="element-200">
                  $19.500 ARS
                </span>
              </div>
            </div>
            <Button size="md" className="w-full" href="https://globalnovapro.shop/cart/43941129322539:1" data-id="element-201">
              → QUIERO MI KIT PROFESIONAL AHORA
            </Button>
          </div>

          <div className="bg-gradient-to-b from-[#251a45] to-dark-bg border-2 border-primary rounded-2xl p-6 flex flex-col justify-between relative" data-id="element-202">
            <div data-id="element-203">
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-204">
                🚀 KIT COMPLETO + ACELERADOR ⭐
              </h3>
              <div className="mb-6" data-id="element-205">
                <span className="text-gray-500 line-through mr-2" data-id="element-206">$89.000</span>
                <span className="text-3xl font-black text-white" data-id="element-207">
                  $27.500 ARS
                </span>
              </div>
            </div>
            <Button size="md" className="w-full" href="https://globalnovapro.shop/cart/43941131878443:1" data-id="element-208">
              → QUIERO EL KIT COMPLETO + ACELERADOR
            </Button>
          </div>
        </div>
      </div>
    </div>;
};